import { Button, Form, Input, message, Space } from "antd";
import _t from "../../lang/translate";
import { OpenModalProps } from "../../types/modalTypes";
import assertFC from "../../utilities/assertFC";
import { renderErrorMessage } from "../messages/errorMessage";

const { TextArea } = Input;

export default function Note<T extends object>({ onSuccess, onCancel, payload }: OpenModalProps<T>) {
  const [reviewForm] = Form.useForm<{ note: string }>();

  const handleSubmit = () => {
    const values = reviewForm.getFieldsValue();
    try {
      onSuccess(values as T);
    } catch (error) {
      renderErrorMessage(error)
    }
  };

  return (
    <Form
      form={reviewForm}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <h2 className="modal-title">{_t("activity", "note")}</h2>
      <Form.Item name="note">
        <TextArea autoSize={{ maxRows: 6, minRows: 2 }} placeholder={_t("notes")} />
      </Form.Item>

      <div className="text-right">
        <Space>
          <Button onClick={onCancel} type="primary" >
            {_t("cancel")}
          </Button>
          <Button htmlType="submit" type="primary" >
            {_t("apply")}
          </Button>
        </Space>
      </div>
    </Form>
  );
}

assertFC(Note);
